import React from "react";
import { useNavigate } from "react-router-dom";
import { ButtonSpecial2, Container, StyledDialog } from "./userMenuElements";
import Slide from "@mui/material/Slide";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { logout, selectBlockRetiro, selectId, selectLogged, selectNotVerifiedPeru, selectToken, selectUser, setActivePage } from "../../features/user/userSlice";
import {
  selectShowUserMenuMobile,
  setShowJumio,
  setShowUserDepositModal,
  setShowUserMenuMobile,
  setShowUserWithdrawModal,
  setUrlverify,
} from "../../features/modals/modalsSlice";
import { useCookies } from "react-cookie";
import MenuItems from "../userMenu/MenuItems";
import { clearLimites, selectLimites, setLimites } from "../../features/limitaciones/limitacionesSlice";
import axios from "axios";
import { API_URL } from "../../const/api";
import { comprobarTiempoInactivo } from "../../utils/tools";
import { errorNotification, infoNotification } from "../../utils/toastNotifications";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import SwalBlockRetiro from "../SwalBlockRetiro";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const UserMenuMobile = () => {
  const showUserMenu = useSelector(selectShowUserMenuMobile);
  const [t] = useTranslation("global");
  const [cookies, removeCookie] = useCookies(["user"]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const usuario = useSelector(selectUser)
  const notVerifiedPeru = useSelector(selectNotVerifiedPeru);
  const limitaciones = useSelector(selectLimites);
  const id_uo = useSelector(selectId);
  const token = useSelector(selectToken);
  const isLoged = useSelector(selectLogged);

  const blockRetiro = useSelector(selectBlockRetiro)

  const getLimitaciones = async () => {
    let body = { id_uo, token };
    let tiempo_inactivo = ''
    try {
      const res = await axios.post(API_URL + "getLimitaciones", body);
      if (res.data.response !== null) {
        dispatch(setLimites(res.data.response));
        const fecha_config = res.data.response.fecha_config;
        tiempo_inactivo = res.data.response.tiempo_inactivo;

        //validamos si se cumplio el tiempo de inactividad
        if(tiempo_inactivo > 0 && fecha_config && comprobarTiempoInactivo(fecha_config)) {
          // se cumplio el tiempo de inactividad y lo seteamos a 0
          body = {...body, ...limitaciones, tiempo_inactivo: 0, fecha_config: null}
          const res = await axios.post(API_URL + "setLimitaciones", body);
          if(res.data.response==='ok') {
            dispatch(setLimites({...limitaciones, tiempo_inactivo: 0, fecha_config: null}))
          }
        } 
      } 
    } catch (error) {
      //console.log(error);
    }

    return tiempo_inactivo;
  };

  const handleClick = (link) => {
    dispatch(setActivePage(link));
    dispatch(setShowUserMenuMobile(false));
  };

  const exit = async () => {
    await axios.post(API_URL + "registroCerrarSesion",{usuario});
    removeCookie("MBA");
    removeCookie("MBB");
    dispatch(setShowUserMenuMobile(false));
    dispatch(logout({}));
    dispatch(clearLimites({}));
    //navigate('/');
    window.location.href = "/";
  };


  const verificacionJumio = async () => {
    let body = {
      id_uo,
      token,
    };
    const res = await axios.post(API_URL + "verify", body);
    if (res.data.code === 200) {
      dispatch(setUrlverify(res.data.response_data.web.href));
      dispatch(setShowJumio(true));
    } else {
      if (res.data.message) {
        errorNotification(res.data.message, "top-center");
      } else {
        errorNotification(t("alert.errorNotificationRetiro-66"), "top-center");
      }
    }
  }

  const handleClose = () => {
    dispatch(setShowUserMenuMobile(false));
  };

  const handleClickTrans = (name) => {
    if (name === "deposit" && limitaciones.tiempo_inactivo<=0)
      dispatch(setShowUserDepositModal({ open: true, type: false }));
    if (name === "withdraw" && !blockRetiro)
      dispatch(setShowUserDepositModal({ open: true, type: true }));

    if((name==='deposit') && isLoged && limitaciones.tiempo_inactivo>0) {
      const tiempo = getLimitaciones();
      if(limitaciones.tiempo_inactivo>0) {
        infoNotification("Su cuenta se encuentra inactiva por indicaciones del usuario.")
      } 
    }
    if(isLoged && name === "withdraw" && blockRetiro) {
      SwalBlockRetiro(verificacionJumio)
    }
  }

  return (
    <StyledDialog
      open={showUserMenu}
      TransitionComponent={Transition}
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      sx={{ borderRadius: 0, zIndex: 1900 }}
      fullWidth={true}
      fullScreen
    >
      <Container>
        <div className="btns-mob">
          <ButtonSpecial2
            bg="primary"
            onClick={()=>handleClickTrans('deposit')}
          >
            <span>{t("header.btn-deposit")}</span>
          </ButtonSpecial2>

          <ButtonSpecial2
            onClick={()=>handleClickTrans('withdraw')}
          >
            <span>{t("header.btn-withdraw")}</span>
          </ButtonSpecial2>
        </div>
        <MenuItems handleClick={handleClick} exit={exit} />
      </Container>
    </StyledDialog>
  );
};

export default UserMenuMobile;
